import { BaseUpdateDto } from '../../base/dtos/base-update.dto';

/**
 * Update record status DTO
 */
export class UpdateRecordStatusDto<TStatus> extends BaseUpdateDto {
	status!: TStatus;
}
